import {
    File,
    FileArchive,
    FileAudio,
    FileImage,
    FileText,
    FileVideo,
} from 'lucide-react';

export type FileTypes =
    | 'image'
    | 'video'
    | 'audio'
    | 'pdf'
    | 'compressed'
    | 'code'
    | 'text'
    | 'document';

export function CommentFileIcon({ type }: { type?: FileTypes }) {
    if (!type) return <File className="h-6 w-6 text-gray-500" />;
    if (type.includes('image'))
        return <FileImage className="text-ata-pink h-6 w-6 rounded-lg" />;
    if (type.includes('audio'))
        return <FileAudio className="text-ata-green h-6 w-6" />;
    if (type.includes('video'))
        return <FileVideo className="text-ata-pink h-6 w-6" />;
    if (type.includes('compressed') || type.includes('zip'))
        return <FileArchive className="text-ata-gold h-6 w-6" />;
    if (type.includes('text') || type.includes('document'))
        return <FileText className="text-ata-light-blue" />;
}
